import "silverstripe";

export const _t = window.ss.i18n._t.bind(window.ss.i18n);

export const sprintf = window.ss.i18n.sprintf.bind(window.ss.i18n);